import { Component, OnDestroy, OnInit } from "@angular/core";
import { CommandAsync, ICommand } from "@nahuelmorata/ngx-command";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngxs/store";
import { firstValueFrom, Subscription } from "rxjs";
import { ClienteDTO } from "@DTOS";
import { ModalService, NotificacionServiceEmisor } from "@shared/services";
import { ClientesAcciones, EstadoEnum, State } from "@shared/states";
import { filter, take } from "rxjs/operators";
import { AccionEnum } from "@shared/enums";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";


@Component({
    selector: "app-cliente-modal",
    templateUrl: "./cliente-modal.component.html",
    styleUrls: ["./cliente-modal.component.scss"]
})
export class ClienteModalComponent implements OnInit, OnDestroy {
    public editando = false;
    public cliente = new ClienteDTO();

    public agregarCmd: ICommand = new CommandAsync(() => this.agregar());
    public guardarCmd: ICommand = new CommandAsync(() => this.guardar());
    public borrarCmd: ICommand = new CommandAsync(() => this.borrarConConfirmar());

    protected esMobile = false;

    private subs = new Subscription();

    constructor(private activeModal: NgbActiveModal, private store: Store, private modalService: ModalService,
        private notificacionService: NotificacionServiceEmisor, private breakpointsObserver: BreakpointObserver) { }

    ngOnInit() {
        this.subs.add(
            this.breakpointsObserver.observe([Breakpoints.Handset]).subscribe(breakdpointState => {
                this.esMobile = breakdpointState.matches;
            })
        );
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    public cerrar(): void {
        this.activeModal.dismiss();
    }

    private async agregar() {
        this.store.dispatch(new ClientesAcciones.Agregar(this.cliente));
        await this.esperarRespuesta(AccionEnum.AGREGAR, "Error al crear un cliente");
    }

    private async guardar() {
        this.store.dispatch(new ClientesAcciones.Actualizar(this.cliente));
        await this.esperarRespuesta(AccionEnum.ACTUALIZAR, "Error al guardar un cliente");
    }

    private async borrarConConfirmar() {
        const confirmacion = await this.modalService.openModalDecision("¿Esta seguro que quiere eliminar el cliente?");
        if (!confirmacion) {
            return;
        }
        await this.borrar();
    }

    private async borrar() {
        this.store.dispatch(new ClientesAcciones.Borrar(this.cliente));
        await this.esperarRespuesta(AccionEnum.BORRAR, "Error al borrar un cliente");
    }

    private procesarRespuesta() {
        this.activeModal.close(this.cliente);
        this.store.dispatch(new ClientesAcciones.LimpiarEstadoAccion());
    }

    private async esperarRespuesta(accion: AccionEnum, mensajeError: string) {
        const estadoAccion = await firstValueFrom(
            this.store.select((state: State) => state.clientes.estadoAccion).pipe(
                filter(estado => estado != null && estado.accion === accion),
                take(1)
            )
        );
        if (estadoAccion == null) {
            return;
        }
        if (estadoAccion.estado === EstadoEnum.CORRECTO && estadoAccion.entidad != null) {
            this.cliente = estadoAccion.entidad;
            this.procesarRespuesta();
        } else {
            this.notificacionService.notificarError(mensajeError);
        }
    }
}
